/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2023-06-14 09:34:42
 * @Description: 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { trackPv } from "@/utils/track";

Vue.use(VueRouter)

//以下代码解决路由地址重复的报错问题
// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const routes = [
    //首页
  {
    path: '/',
    redirect: {
		name: 'Home',
	}
  },
  {
    path: '/home',
    name: 'Home',
    meta:{pathSet:"/home"},
    component: () => import("@/views/home/Home.vue")
  },
  //注册
  {
    path: '/register',
    name: 'Register',
    component: () => import("@/views/login/Register.vue")
  },
  //登录
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: () => import("@/views/login/ForgetPassword.vue")
  },
  //api文档
  {
    path: '/apiDoc',
    name: 'ApiDoc',
    redirect:{name:'apiDocIndex'},
    component: () => import("@/views/apiDoc/Index.vue"),
    children:[{
      path:"/apiDoc/index",
      name:"apiDocIndex",
      meta:{pathSet:"/apiDoc",title:"极兔API简介"},
      component:() => import("@/views/apiDoc/apiDocIndex.vue"),
    },{
      path:"/apiDoc/basic",
      name:"basic",
      meta:{pathSet:"/apiDoc",title:"获取极兔省市区"},
      component:() => import("@/views/apiDoc/children/basic/index.vue"),
    },{
      path:"/apiDoc/orderserve/create",
      name:"createOrder",
      meta:{pathSet:"/apiDoc",title:"创建订单"},
      component:() => import("@/views/apiDoc/children/orderserve/create.vue"),
    },{
      path:"/apiDoc/orderserve/query",
      name:"queryOrder",
      meta:{pathSet:"/apiDoc",title:"查询订单"},
      component:() => import("@/views/apiDoc/children/orderserve/query.vue"),
    },{
      path:"/apiDoc/orderserve/cancel",
      name:"cancelOrder",
      meta:{pathSet:"/apiDoc",title:"取消订单"},
      component:() => import("@/views/apiDoc/children/orderserve/cancel.vue"),
    },
    {
      path:"/apiDoc/orderserve/statusFeedback",
      name:"orderStatusFeedback",
      meta:{pathSet:"/apiDoc",title:"订单状态回传"},
      component:() => import("@/views/apiDoc/children/orderserve/statusFeedback.vue"),
    },
    {
      path:"/apiDoc/orderserve/comCostAndTime",
      name:"comCostAndTime",
      meta:{pathSet:"/apiDoc",title:"运费时效查询"},
      component:() => import("@/views/apiDoc/children/orderserve/ComCostAndTime.vue"),
    },
    {
      path:"/apiDoc/orderserve/addLooseOrder",
      name:"addLooseOrder",
      meta:{pathSet:"/apiDoc",title:"订单状态回传"},
      component:() => import("@/views/apiDoc/children/orderserve/addLooseOrder.vue"),
    },
    {
      path:"/apiDoc/vip/query",
      name:"vipQuery",
      meta:{pathSet:"/apiDoc",title:"电子面单账号检验"},
      component:() => import("@/views/apiDoc/children/vip/query.vue"),
    },
    {
      path:"/apiDoc/vip/balance",
      name:"vipBalance",
      meta:{pathSet:"/apiDoc",title:"电子面单余额查询"},
      component:() => import("@/views/apiDoc/children/vip/balance.vue"),
    },
    {
      path:"/apiDoc/orderserve/getPrint",
      name:"getPrint",
      meta:{pathSet:"/apiDoc",title:"获取电子面单"},
      component:() => import("@/views/apiDoc/children/orderserve/getPrint"),
    },{
      path:"/apiDoc/logistics/query",
      name:"logisticsQuery",
      meta:{pathSet:"/apiDoc",title:"物流轨迹查询"},
      component:() => import("@/views/apiDoc/children/logistics/query.vue"),
    },
    {
      path:"/apiDoc/logistics/statusFeedback",
      name:"logisticsStatusFeedback",
      meta:{pathSet:"/apiDoc",title:"物流轨迹回传"},
      component:() => import("@/views/apiDoc/children/logistics/statusFeedback.vue"),
    },{
      path:"/apiDoc/logistics/subscribe",
      name:"logisticsSubscribe",
      meta:{pathSet:"/apiDoc",title:"物流轨迹订阅"},
      component:() => import("@/views/apiDoc/children/logistics/subscribe.vue"),
    },{
      path:"/apiDoc/other/cover",
      name:"othercover",
      meta:{pathSet:"/apiDoc",title:"超区查询"},
      component:() => import("@/views/apiDoc/children/other/cover.vue"),
    },{
      path:"/apiDoc/other/pca",
      name:"otherpca",
      meta:{pathSet:"/apiDoc",title:"收派范围查询"},
      component:() => import("@/views/apiDoc/children/other/pca.vue"),
    },{
      path:"/apiDoc/other/getInfo",
      name:"othergetInfo",
      meta:{pathSet:"/apiDoc",title:"网点信息及三段码查询"},
      component:() => import("@/views/apiDoc/children/other/getInfo.vue"),
    },{
      path:"/apiDoc/other/settlementReturn",
      name:"settlementReturn",
      meta:{pathSet:"/apiDoc",title:"结算账单回传"},
      component:() => import("@/views/apiDoc/children/other/settlementReturn.vue"),
    },{
      path:"/apiDoc/other/realNameSaveInfo",
      name:"realNameSaveInfo",
      meta:{pathSet:"/apiDoc",title:"实名制信息上传"},
      component:() => import("@/views/apiDoc/children/other/realNameSaveInfo.vue"),
    },
    {
      path:"/apiDoc/other/freight",
      name:"freight",
      meta:{pathSet:"/apiDoc",title:"运费计算"},
      component:() => import("@/views/apiDoc/children/other/freight.vue"),
    },
    {
      path:"/apiDoc/other/threeSegmentCode",
      name:"threeSegmentCode",
      meta:{pathSet:"/apiDoc",title:"三段码查询(新)"},
      component:() => import("@/views/apiDoc/children/other/threeSegmentCode.vue"),
    },
    {
      path:"/apiDoc/other/weight",
      name:"weight",
      meta:{pathSet:"/apiDoc",title:"重量推送"},
      component:() => import("@/views/apiDoc/children/other/weight.vue"),
    },
    {
      path:"/apiDoc/other/weightSubscribe",
      name:"weightSubscribe",
      meta:{pathSet:"/apiDoc",title:"重量订阅"},
      component:() => import("@/views/apiDoc/children/other/weightSubscribe.vue"),
    },{
      path:"/apiDoc/other/dceApply",
      name:"dceApply",
      meta:{pathSet:"/apiDoc",title:"Dce申报"},
      component:() => import("@/views/apiDoc/children/other/dceApply.vue"),
    },{
      path:"/apiDoc/customs/addOrder",
      name:"customsAddOrder",
      meta:{pathSet:"/apiDoc",title:"清关下单"},
      component:() => import("@/views/apiDoc/children/customs/addOrder.vue"),
    },{
      path:"/apiDoc/customs/updateOrder",
      name:"customsUpdateOrder",
      meta:{pathSet:"/apiDoc",title:"更新清关订单"},
      component:() => import("@/views/apiDoc/children/customs/updateOrder.vue"),
    },{
      path:"/apiDoc/customs/addFlight",
      name:"customsAddFlight",
      meta:{pathSet:"/apiDoc",title:"清关下发航班信息"},
      component:() => import("@/views/apiDoc/children/customs/addFlight.vue"),
    },{
      path:"/apiDoc/customs/orderDetail",
      name:"customsOrderDetail",
      meta:{pathSet:"/apiDoc",title:"清关订单详情"},
      component:() => import("@/views/apiDoc/children/customs/orderDetail.vue"),
    },{
      path:"/apiDoc/customs/cancelOrder",
      name:"customsCancelOrder",
      meta:{pathSet:"/apiDoc",title:"取消清关单"},
      component:() => import("@/views/apiDoc/children/customs/cancelOrder.vue"),
    },{
      path:"/apiDoc/customs/printOrder",
      name:"customsPrintOrder",
      meta:{pathSet:"/apiDoc",title:"打印清关单"},
      component:() => import("@/views/apiDoc/children/customs/printOrder.vue"),
    },{
      path:"/apiDoc/customs/printBox",
      name:"customsPrintBox",
      meta:{pathSet:"/apiDoc",title:"清关打印大包"},
      component:() => import("@/views/apiDoc/children/customs/printBox.vue"),
    },{
      path:"/apiDoc/customs/updateDir",
      name:"customsUpdateDir",
      meta:{pathSet:"/apiDoc",title:"更新DIR"},
      component:() => import("@/views/apiDoc/children/customs/updateDir.vue"),
    }
  ]
  },
  //个人中心
  {
      path:"/personalCenter",
      name:"PersonalCenter",
      component: () => import("@/views/personalCenter/Index.vue")
  },
  //控制台
  {
    path:"/control",
    name:"Control",
    meta:{pathSet:"/control"},
    component: () => import("@/views/control/Index.vue")
  },
  {
    path:"/helpCenter",
    name:"HelpCenter",
    meta:{pathSet:"/helpCenter"},
    component: () => import("@/views/helpCenter/Index.vue")
  },
  // 管我们
  {
    path:"/aboutUs",
    name:"AboutUs",
    meta:{pathSet:"/aboutUs"},
    component: () => import("@/views/aboutUs/Index.vue")
  }
]

const router = new VueRouter({
//   mode: 'history',
  routes
})

router.afterEach((to, from) => {
  trackPv(to, from);
});

export default router
